import { useState, useEffect, useRef } from "react";
import { useLang } from "../../i18n/LanguageContext";

function useCountUp(target, duration = 2000) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const startTime = performance.now();
          const step = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            setCount(Math.floor(progress * target));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);
  return { count, ref };
}

function StatCard({ target, suffix = "+", label, accent }) {
  const { count, ref } = useCountUp(target);
  return (
    <div ref={ref} className={`p-8 glass-card rounded text-center space-y-2 border-l-4 ${accent}`}>
      <div className="text-5xl font-black text-white tracking-tight">{count}{suffix}</div>
      <div className="text-[10px] uppercase text-zinc-500 font-black tracking-wider">{label}</div>
    </div>
  );
}

export default function Stats() {
  const { t } = useLang();
  return (
    <div className="lg:col-span-5 grid grid-cols-2 gap-4">
      <StatCard target={35}   suffix="+" label={t.stats.projects} accent="border-[#F28C18]" />
      <StatCard target={15}   suffix="+" label={t.stats.partners}  accent="border-zinc-600" />
      <StatCard target={30}   suffix="+" label={t.stats.years}     accent="border-zinc-600" />
      <div className="p-8 glass-card rounded text-center space-y-2 border-l-4 border-[#F28C18]">
        <div className="text-5xl font-black text-white tracking-tight">24/7</div>
        <div className="text-[10px] uppercase text-zinc-500 font-black tracking-wider">{t.stats.support}</div>
      </div>
    </div>
  );
}
